import React from 'react';
import clsx from 'clsx';
import { dateFormatter, timeFormatter } from '@/utils/dateHelper';
import SimpleCell from './SimpleCell';

const DateCell = ({
  children,
  className,
  collapsing,
  colSpan,
  content,
  disabled,
  textAlign,
}) => (
  <SimpleCell
    className={clsx('aridhia-date-cell', className)}
    content={content ? dateFormatter(content) : undefined}
    disabled={disabled}
    colSpan={colSpan}
    collapsing={collapsing}
    textAlign={textAlign}
    title={content ? `${dateFormatter(content)} - ${timeFormatter(content)}` : undefined}
  >
    {children}
  </SimpleCell>
);

export default DateCell;
